import {
  Download,
  Phone,
  Plus,
  Settings2,
  ShieldCheck,
  Trash2,
  UserCheck,
  UserRoundCheck,
  UserRoundPen,
} from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { ACTIONS, RESOURCES, ROLES } from '../config/accessControl';
import { findNavigationItem } from '../config/navigation';
import Button from '../components/common/Button';
import Card from '../components/common/Card';
import EmptyState from '../components/common/EmptyState';
import PermissionGate from '../components/common/PermissionGate';
import Input from '../components/forms/Input';
import { useAuth } from '../context/AuthContext';
import usePermissions from '../hooks/usePermissions';

function AdminModulePage() {
  const { pathname } = useLocation();
  const item = findNavigationItem(pathname);
  const Icon = item?.icon;
  const { user } = useAuth();
  const { canEdit } = usePermissions();

  const actions = [
    { action: ACTIONS.CREATE, label: 'Crear', icon: Plus, variant: 'primary' },
    { action: ACTIONS.EDIT, label: user.role === ROLES.ADMINISTRADOR_GENERAL ? 'Editar campos autorizados' : 'Editar', icon: UserRoundPen, variant: 'outline' },
    { action: ACTIONS.CALL, label: 'Registrar llamada', icon: Phone, variant: 'outline' },
    { action: ACTIONS.VALIDATE, label: 'Validar', icon: UserCheck, variant: 'outline' },
    { action: ACTIONS.RESOLVE, label: 'Resolver', icon: UserRoundCheck, variant: 'outline' },
    { action: ACTIONS.ASSIGN, label: 'Asignar', icon: ShieldCheck, variant: 'outline' },
    { action: ACTIONS.EXPORT, label: 'Exportar', icon: Download, variant: 'outline' },
    { action: ACTIONS.CONFIGURE, label: 'Configurar', icon: Settings2, variant: 'outline' },
    { action: ACTIONS.DELETE, label: 'Eliminar', icon: Trash2, variant: 'danger' },
  ];

  return (
    <div>
      <div className="mb-7 flex flex-col justify-between gap-4 xl:flex-row xl:items-end">
        <div>
          <h2 className="text-2xl font-semibold tracking-tight text-content-primary">{item?.name}</h2>
          <p className="mt-1 text-sm text-content-muted">Las acciones disponibles se ajustan a los permisos del rol activo.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          {actions.map(({ action, label, icon: ActionIcon, variant }) => (
            <PermissionGate key={action} resource={item.resource} action={action}>
              <Button variant={variant} size="sm">
                <ActionIcon className="size-4" />
                {label}
              </Button>
            </PermissionGate>
          ))}
        </div>
      </div>

      {item.resource === RESOURCES.VOTERS && (
        <Card className="mb-5" title="Ejemplo de permisos por campo" description="Los controles deshabilitados no pueden modificarse con el rol actual.">
          <div className="grid gap-4 sm:grid-cols-2">
            <Input id="permission-document" label="Documento" defaultValue="4.582.921" disabled={!canEdit(RESOURCES.VOTERS, 'document')} />
            <Input id="permission-phone" label="Teléfono" defaultValue="0981 555 010" disabled={!canEdit(RESOURCES.VOTERS, 'phone')} />
          </div>
        </Card>
      )}

      <EmptyState
        icon={Icon}
        title={`Módulo de ${item?.name}`}
        description="El contenido funcional se implementará en la fase correspondiente."
      />
    </div>
  );
}

export default AdminModulePage;
